import React from 'react'
import Navbar from '../components/Navbar'
import Hero from '../components/Hero'
import bgContact from '../assets/images/bgContact.jpg'
import Footer from '../components/Footer'
import ContactForm from '../components/ContactForm'


function Contact() {
    return (
        <div>
            <Navbar />
            <Hero
                cName="hero"
                heroImg={bgContact}
                headingText="Step into History: Virtual Reality Tours with an Interactive AI Guide"
                paraText="Welcome to our innovative platform, where history comes to life through the seamless integration of virtual reality (VR) history tours and an interactive AI guide. At our core, we offer an inexpensive and enjoyable way for individuals to explore and learn about significant historical sites, cultures, and traditions."
                url="/"
                linkText="Visit Now"
            />
            <ContactForm />
            <Footer />
        </div>
    )
}

export default Contact

